/* « Le 21 du Jarl » : la fenetre de jeu promo (snippet vd-jeu-21.liquid).
   Les regles vivent dans vd-jeu-21-regles.js, charge avant ce fichier.

   Une fenetre <dialog> native : piege a focus, Echap et role modal viennent
   du navigateur. Cadre juridique et CNIL : docs/benchmark-2026-10-17/
   03-popup-jeu-cadre-legal.md, section 2.7. D'ou trois choix :
   - l'onglet lateral ouvre le jeu a la demande, partout ;
   - l'ouverture automatique n'a lieu que sur ordinateur (un interstitiel
     couvrant la page d'un telephone gene l'achat) et seulement si le
     visiteur a accepte les cookies de preferences, puisqu'elle doit se
     souvenir de ne pas revenir avant une semaine ;
   - rien n'est ecrit dans le navigateur avant le clic « Distribuer » : le
     stockage ne garde que l'etat du jeu (manches du jour, code gagne).
   Aucun texte en dur : tout vient du JSON pose par le Liquid. */
(function () {
  'use strict';

  var racine = document.querySelector('[data-vd-jeu21]');
  var R = window.VDJeu21Regles;
  if (!racine || !R) return;

  var dialogue = racine.querySelector('[data-jeu21-dialogue]');
  var lanceur = racine.querySelector('[data-jeu21-ouvrir]');
  var etat = racine.querySelector('[data-jeu21-etat]');
  var gain = racine.querySelector('[data-jeu21-gain]');
  var zones = {
    joueur: racine.querySelector('[data-cartes-joueur]'),
    croupier: racine.querySelector('[data-cartes-croupier]')
  };
  var totaux = {
    joueur: racine.querySelector('[data-total-joueur]'),
    croupier: racine.querySelector('[data-total-croupier]')
  };
  var textes = JSON.parse(racine.querySelector('[data-jeu21-textes]').textContent);
  var runes = JSON.parse(racine.querySelector('[data-jeu21-runes]').textContent);
  var code = racine.getAttribute('data-code');
  var manchesMax = Number(racine.getAttribute('data-manches')) || 3;
  var delai = (Number(racine.getAttribute('data-delai')) || 15) * 1000;
  var reduit = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var CLE = 'vd-jeu21-v1';
  var PAUSE_JOURS = 7;

  var partie = null;

  function aujourdhui() {
    return new Date().toISOString().slice(0, 10);
  }

  function lire() {
    try {
      var brut = JSON.parse(window.localStorage.getItem(CLE) || '{}');
      if (brut.jour !== aujourdhui()) brut.manches = 0;
      return brut;
    } catch (e) {
      return {};
    }
  }

  function ecrire(memo) {
    memo.jour = aujourdhui();
    try {
      window.localStorage.setItem(CLE, JSON.stringify(memo));
    } catch (e) {
      /* Stockage refuse (navigation privee) : le jeu marche, sans memoire. */
    }
  }

  function preferencesAutorisees() {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    return Boolean(cp && typeof cp.preferencesProcessingAllowed === 'function' && cp.preferencesProcessingAllowed());
  }

  function chargerConsentement(suite) {
    if (window.Shopify && window.Shopify.customerPrivacy) return suite();
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (erreur) {
        if (!erreur) suite();
      });
    }
  }

  /* Le code va directement dans le panier (vd-jeu-21-remise.js) et ne se dit
     pose que si la reponse le rend applicable ; sinon, copier et saisir. */
  function appliquerAuPanier() {
    if (!window.VDJeu21Remise) return dire(textes.gagne_a_saisir);
    return window.VDJeu21Remise.appliquer(code).then(function (posee) {
      dire(posee ? textes.gagne_applique : textes.gagne_a_saisir);
    }).catch(function () {
      dire(textes.gagne_a_saisir);
    });
  }

  function formater(gabarit, valeurs) {
    return gabarit.replace(/__([A-Z]+)__/g, function (tout, nom) {
      return nom in valeurs ? valeurs[nom] : tout;
    });
  }

  function dire(message) {
    etat.textContent = message;
  }

  function montrer(action, visible) {
    var bouton = racine.querySelector('[data-action="' + action + '"]');
    if (bouton) bouton.hidden = !visible;
  }

  function boutons(liste) {
    ['jouer', 'tirer', 'rester', 'rejouer'].forEach(function (a) {
      montrer(a, liste.indexOf(a) !== -1);
    });
  }

  function dessinerCarte(carte, cachee) {
    var li = document.createElement('li');
    li.className = 'carte' + (cachee ? ' carte--dos' : '') + (reduit ? '' : ' carte--entre');
    if (cachee) {
      li.setAttribute('aria-label', textes.carte_cachee);
      return li;
    }
    var rune = runes[carte.couleur];
    li.style.setProperty('--teinte', rune.couleur);
    li.setAttribute('aria-label', formater(textes.carte, { RANG: textes.rangs[carte.rang], RUNE: rune.nom }));
    var rang = document.createElement('span');
    rang.className = 'carte__rang';
    rang.setAttribute('aria-hidden', 'true');
    rang.textContent = carte.rang;
    li.appendChild(rang);
    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 100 140');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    var trace = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    trace.setAttribute('d', rune.trace);
    svg.appendChild(trace);
    li.appendChild(svg);
    return li;
  }

  function afficher(qui, revele) {
    var main = partie[qui];
    zones[qui].replaceChildren();
    main.forEach(function (carte, i) {
      zones[qui].appendChild(dessinerCarte(carte, qui === 'croupier' && i === 1 && !revele));
    });
    totaux[qui].textContent = qui === 'croupier' && !revele ? '' : String(R.valeurMain(main).total);
  }

  function nouvelleManche() {
    gain.hidden = true;
    var sabot = R.creerSabot(Object.keys(runes));
    partie = { sabot: sabot, joueur: [sabot.pop()], croupier: [sabot.pop()], fini: false };
    partie.joueur.push(sabot.pop());
    partie.croupier.push(sabot.pop());
    afficher('joueur', false);
    afficher('croupier', false);
    if (R.estBlackjack(partie.joueur)) return conclure();
    boutons(['tirer', 'rester']);
    dire(formater(textes.a_toi, { TOTAL: R.valeurMain(partie.joueur).total }));
    racine.querySelector('[data-action="tirer"]').focus();
  }

  function tirer() {
    if (!partie || partie.fini) return;
    partie.joueur.push(partie.sabot.pop());
    afficher('joueur', false);
    var total = R.valeurMain(partie.joueur).total;
    if (total >= 21) return conclure();
    dire(formater(textes.a_toi, { TOTAL: total }));
  }

  function conclure() {
    partie.fini = true;
    boutons([]);
    if (R.valeurMain(partie.joueur).total <= 21 && !R.estBlackjack(partie.joueur)) {
      R.jouerCroupier(partie.croupier, partie.sabot);
    }
    afficher('croupier', true);
    var fin = R.issue(partie.joueur, partie.croupier);
    var memo = lire();
    if (fin === 'egalite') {
      dire(textes.egalite);
      boutons(['rejouer']);
      racine.querySelector('[data-action="rejouer"]').focus();
    } else if (fin === 'gagne') {
      memo.gagne = code;
      ecrire(memo);
      dire(textes.gagne);
      gain.hidden = false;
      gain.querySelector('[data-action="copier"]').focus();
      appliquerAuPanier();
    } else {
      memo.manches = (memo.manches || 0) + 1;
      ecrire(memo);
      var reste = manchesMax - memo.manches;
      if (reste > 0) {
        dire(formater(textes.perdu, { RESTE: reste }));
        boutons(['rejouer']);
        racine.querySelector('[data-action="rejouer"]').focus();
      } else {
        dire(textes.plus_de_manche);
        racine.querySelector('[data-jeu21-fermer]').focus();
      }
    }
  }

  function copier(bouton) {
    var fini = function () {
      bouton.textContent = textes.copie;
    };
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(code).then(fini, function () {
        dire(textes.copie_impossible);
      });
    } else {
      dire(textes.copie_impossible);
    }
  }

  function ouvrir(automatique) {
    if (dialogue.open) return;
    var memo = lire();
    if (automatique === true) {
      memo.vu = Date.now();
      ecrire(memo);
    }
    dialogue.showModal();
    if (memo.gagne === code) {
      boutons([]);
      gain.hidden = false;
      dire(textes.deja_gagne);
    } else if ((memo.manches || 0) >= manchesMax) {
      boutons([]);
      dire(textes.plus_de_manche);
    } else if (!partie || partie.fini) {
      boutons(['jouer']);
      dire(formater(textes.accueil, { MANCHES: manchesMax - (memo.manches || 0) }));
    }
  }

  function ouvertureAuto() {
    if (racine.getAttribute('data-auto') !== 'true') return false;
    if (!window.matchMedia('(min-width: 900px)').matches) return false;
    if (!preferencesAutorisees()) return false;
    var memo = lire();
    if (memo.gagne || (memo.vu && Date.now() - memo.vu < PAUSE_JOURS * 864e5)) return false;
    return true;
  }

  /* Jamais par-dessus le panier ouvert ni la banniere de consentement : le
     choix des cookies passe avant le jeu. */
  function pageOccupee() {
    var banniere = document.getElementById('shopify-pc__banner');
    return Boolean(
      document.querySelector('dialog[open], [data-vd-tiroir].est-ouvert') ||
      (banniere && banniere.offsetParent !== null)
    );
  }

  function tenterOuverture() {
    if (!ouvertureAuto() || pageOccupee()) return;
    ouvrir(true);
  }

  racine.addEventListener('click', function (e) {
    var cible = e.target.closest('[data-action]');
    if (!cible) return;
    var action = cible.getAttribute('data-action');
    if (action === 'jouer' || action === 'rejouer') nouvelleManche();
    else if (action === 'tirer') tirer();
    else if (action === 'rester') conclure();
    else if (action === 'copier') copier(cible);
  });
  racine.querySelector('[data-jeu21-fermer]').addEventListener('click', function () {
    dialogue.close();
  });
  dialogue.addEventListener('click', function (e) {
    if (e.target === dialogue) dialogue.close();
  });
  lanceur.addEventListener('click', function () {
    ouvrir(false);
  });
  lanceur.hidden = false;

  chargerConsentement(function () {
    if (!ouvertureAuto()) return;
    window.setTimeout(tenterOuverture, delai);
    document.addEventListener('mouseout', function sortie(e) {
      if (e.relatedTarget === null && e.clientY <= 0) {
        document.removeEventListener('mouseout', sortie);
        tenterOuverture();
      }
    });
  });
})();
